/**
 * LOT-UI-02 — Dashboard responsable magasin (REP-V2).
 */
import React from 'react';
import { Link } from 'react-router-dom';
import { ShoppingCart, Wrench, Users, Package, AlertTriangle, CheckCircle, Clock } from 'lucide-react';
import useActiveMagasin from '../../hooks/useActiveMagasin';
import { DASH_CTA, DASH_PANEL, DashboardKpi, DashboardSectionTitle } from '../../features/dashboard/dashboardV2Ui';

const ResponsableDashboard = ({ stats, username }) => {
  const { code, label } = useActiveMagasin();
  const magStats = stats?.by_magasin?.[code] || stats;
  const showM1Breakdown = code === 'M1' && stats?.by_magasin?.M1;

  return (
    <div className="space-y-5" data-testid="dashboard-responsable">
      <DashboardSectionTitle
        title={`Magasin ${code || '—'}`}
        subtitle={`${label} · Bonjour ${username}`}
      />
      <div className="grid grid-cols-2 lg:grid-cols-3 gap-3">
        <DashboardKpi icon={ShoppingCart} value={magStats?.ventes_jour || 0} label="Ventes du jour" accent="text-gray-400" />
        <DashboardKpi icon={Wrench} value={magStats?.repairs_in_progress || 0} label="Répar. en cours" />
        <DashboardKpi icon={CheckCircle} value={stats?.repairs_completed_today || 0} label="Terminées aujourd'hui" accent="text-emerald-400" />
        <DashboardKpi icon={Clock} value={magStats?.ventes_mois ?? stats?.ventes_mois ?? 0} label="Ventes du mois" accent="text-gray-400" />
        <DashboardKpi icon={Package} value={stats?.stock_faible || 0} label="Stock faible" accent="text-amber-400" />
        <DashboardKpi icon={AlertTriangle} value={stats?.ruptures || 0} label="Ruptures" accent="text-red-400" />
      </div>
      {showM1Breakdown && (
        <div className={`${DASH_PANEL} p-3 text-xs text-gray-500 space-y-1`} data-testid="responsable-m1-breakdown">
          <div>{stats.by_magasin.M1.repairs_in_progress_explicit ?? 0} réparations M1 explicites</div>
          <div>{stats.by_magasin.M1.repairs_in_progress_legacy ?? 0} réparations legacy (pré-M2)</div>
          <div className="text-gray-400">Total affiché : {stats.by_magasin.M1.repairs_in_progress ?? 0}</div>
        </div>
      )}
      <div className="grid grid-cols-2 gap-3">
        <Link to="/pos-v2" className={DASH_CTA} data-testid="responsable-pos-cta">
          <ShoppingCart className="w-8 h-8 text-red-400 mb-2" />
          <span className="font-bold text-sm text-white">Encaisser</span>
        </Link>
        <Link to="/clients" className={`${DASH_PANEL} flex flex-col items-center justify-center p-6 hover:border-white/20 transition-colors`}>
          <Users className="w-8 h-8 text-gray-400 mb-2" />
          <span className="font-bold text-sm text-white">Clients</span>
        </Link>
      </div>
    </div>
  );
};

export default ResponsableDashboard;
